module.exports = __webpack_public_path__ + "static/media/edit.861b1b4e.svg";